import { LogList } from "../../engine/logger/LogList";
import { Container } from "../../ui/containers/Container";
import { Modal } from "../../ui/containers/Modal";
import { Panel } from "../../ui/panels/Panel";
import { PanelGroup } from "../../ui/panels/PanelGroup";
import { RDisplay } from "../../ui/RotDisplay";
import { Scene } from "../../ui/scene";
import { ALIGN_TYPE, TextType, VERT_TYPE } from "../../ui/type/TextType";
import { createElement } from "../../ui/ui";
import { initializeState, gameData } from "../GameManager";
import { MapUI } from "../../ui/map/MapUI";
import { StatsPanel } from "../ui/info/stats/StatsPanel";
import { TileContents } from "../ui/TileContents";
import { InventoryPanel } from "../ui/inventory/InventoryPanel";
import { TopInfo } from "../ui/TopInfo";
export class GameScene extends Scene {
  ui = createElement(
    Container,
    { x: 0, y: 0, w: 80, h: 48 },
    {
      children: [
        createElement(TopInfo, { x: 24, w: 30, y: 0, h: 1 }),
        createElement(MapUI, { x: 24, w: 32, y: 1, h: 35 }),
        createElement(
          PanelGroup,
          { x: 0, y: 0, w: 24, h: 48 },
          {
            children: [
              {
                title: "Stats",
                value: createElement(StatsPanel, { x: 0, y: 0, w: 22, h: 12 }),
              },

              {
                value: createElement(InventoryPanel, {
                  x: 0,
                  y: 0,
                  w: 22,
                  h: 32,
                }),
              },
            ],
          }
        ),
        createElement(
          Panel,
          { x: 23, y: 48 - 12, w: 80 - 23, h: 12 },
          {
            children: [
              createElement(LogList, { x: 0, y: 0, w: 80 - 25, h: 10 }),
            ],
          }
        ),
        createElement(
          Panel,
          { x: 80 - 24, y: 0, w: 24, h: 48 - 11 },
          {
            children: [
              createElement(TileContents, { x: 0, y: 0, w: 22, h: 48 - 13 }),
            ],
          }
        ),
        createElement(Modal, { x: 0, y: 0, w: 80, h: 48 }),
      ],
    }
  );

  constructor() {
    super();
    initializeState();
  }

  update(display: RDisplay, elapsed: number) {
    gameData.gibs.forEach((p) => p.update(elapsed));
    gameData.particles.forEach((p) => p.update(elapsed));
  }
}
